import {ComparisonSlider} from 'react-comparison-slider';
import {Image} from '@shopify/hydrogen';

import {CompareIcon} from '~/components';
import type {PartialDeep} from 'type-fest';
import {useEffect} from 'react';
import {ProductTfr} from '~/lib/types/tfr';

export function ProductDetailBanner({
  product,
}: {
  product: PartialDeep<ProductTfr>;
}) {
  useEffect(() => {
    const comparisonEles: NodeListOf<HTMLElement> =
      document.querySelectorAll('.c-cLrbaH');
    comparisonEles[1].style.zIndex = '15';
    comparisonEles[2].style.zIndex = '15';
  }, []);
  const media = product?.media?.nodes;
  const beforeImage = media?.find((m) => m?.alt == 'before')?.previewImage;
  const afterImage = media?.find((m) => m?.alt == 'after')?.previewImage;
  //Pick the widest aspect to use in case they don't match up
  const beforeAspect =
    beforeImage?.width && beforeImage?.height
      ? beforeImage.width / beforeImage.height
      : -1;
  const afterAspect =
    afterImage?.width && afterImage?.height
      ? afterImage.width / afterImage.height
      : -1;
  const aspect = Math.max(beforeAspect, afterAspect);
  const aspectWithFallback = aspect > 0 ? aspect : 1;
  const titleArray = product.comparison_title?.value?.split(' ');
  return (
    <div className="grid-flow-col grid-cols-1 items-stretch text-white md:grid md:grid-cols-2">
      <div className="flex flex-col items-center justify-center gap-4 bg-acai-900 px-12 py-16">
        <div className="mb-8 text-center text-2xl md:text-4xl">
          {titleArray ? (
            titleArray.map((ele, ind) => {
              if (titleArray.length - 1 === ind) {
                return (
                  <span key={ele + ind} className="font-serif italic">
                    {ele}
                  </span>
                );
              } else {
                return <span key={ele + ind}>{ele} </span>;
              }
            })
          ) : (
            <div>
              How It <span className="font-serif italic">Works</span>
            </div>
          )}
        </div>
        <div className="flex max-w-sm flex-col gap-8 text-center">
          <div>
            {product.comparison_subtitle1?.value ? (
              <div className="pb-2 font-medium uppercase">
                {product.comparison_subtitle1?.value}
              </div>
            ) : (
              <div className="pb-2 font-medium uppercase">before</div>
            )}
            {product.comparison_description1?.value ? (
              <div>{product.comparison_description1?.value}</div>
            ) : (
              <div>
                Hypoallergenic and dermatologically tested. Made without harsh
                chemicals.
              </div>
            )}
          </div>
          <div>
            {product.comparison_subtitle2?.value ? (
              <div className="pb-2 font-medium uppercase">
                {product.comparison_subtitle2?.value}
              </div>
            ) : (
              <div className="pb-2 font-medium uppercase">after</div>
            )}
            {product.comparison_description2?.value ? (
              <div>{product.comparison_description2.value}</div>
            ) : (
              <div>
                Hypoallergenic and dermatologically tested. Made without harsh
                chemicals.
              </div>
            )}
          </div>
          <div>
            {product.comparison_subtitle3?.value && (
              <div className="pb-2 font-medium uppercase">
                {product.comparison_subtitle3?.value}
              </div>
            )}
            {product.comparison_description3?.value && (
              <div>{product.comparison_description3?.value}</div>
            )}
          </div>
        </div>
      </div>
      <div className="[&>*]:!h-full">
        <ComparisonSlider
          defaultValue={50}
          itemOne={
            <div className="relative w-full md:h-full">
              {/* <p className="absolute left-0 z-10 p-4">Before</p> */}
              <Image
                className="w-full object-center brightness-90 md:h-full md:object-cover"
                src={beforeImage?.url ?? '/images/product-detail-banner.png'}
                alt=""
                width={beforeImage?.width ?? 100}
                height={beforeImage?.height ?? 100}
              />
            </div>
          }
          itemTwo={
            <div className="relative w-full md:h-full">
              {/* <p className="absolute right-0 z-10 p-4">After</p> */}
              <Image
                className="w-full object-center brightness-90 md:h-full md:object-cover"
                src={afterImage?.url ?? '/images/product-detail-banner.png'}
                alt=""
                width={afterImage?.width ?? 100}
                height={afterImage?.height ?? 100}
              />
            </div>
          }
          handle={() => <CompareIcon />}
          handleBefore={<div className="h-full w-1 bg-white"></div>}
          handleAfter={<div className="h-full w-1 bg-white"></div>}
          orientation="horizontal"
          aspectRatio={aspectWithFallback}
        />
      </div>
    </div>
  );
}
